import { useEffect, useState } from 'react';
import {
  getCurrentUser,
  signIn,
  signOut,
  signUp,
  autoSignIn,
  confirmSignUp,
  updateUserAttribute,
  confirmUserAttribute
} from 'aws-amplify/auth';
import { Hub } from 'aws-amplify/utils';
import * as Sentry from '@sentry/react';

export const useCognitoAuth = () => {
  const [hasError, setError] = useState(false);

  useEffect(() => {
    Hub.listen('auth', (data) => {
      try {
        switch (data.payload.event) {
          case 'signedIn':
          case 'signInWithRedirect':
            break;
          case 'signInWithRedirect_failure':
            console.log('Sign in failure');
            break;
          default:
            break;
        }
      } catch (error) {
        Sentry.captureException(error);
      }
    });
  }, []);

  // TODO: cognitoで認証方法をメールの認証リンクに変更する
  const handleSignUp = async (username: string, email: string, password: string) => {
    try {
      await signUp({
        username,
        password,
        options: {
          userAttributes: {
            email
          },
          autoSignIn: true
        }
      });
      setError(false);
    } catch (error) {
      setError(true);
      let errorMessage: string;
      if (error instanceof Error) {
        errorMessage = error.message;
      } else {
        errorMessage = '新規登録に失敗しました。';
      }
      throw new Error(errorMessage);
    }
  };

  // 認証コードの確認
  const handleConfirmSignUp = async (username: string, confirmationCode: string) => {
    try {
      await confirmSignUp({ username, confirmationCode });
      await autoSignIn();
      setError(false);
    } catch (error) {
      setError(true);
      let errorMessage: string;
      if (error instanceof Error) {
        errorMessage = error.message;
      } else {
        errorMessage = '認証コードの確認に失敗しました。';
      }
      throw new Error(errorMessage);
    }
  };

  const handleSignIn = async (email: string, password: string) => {
    try {
      await signIn({ username: email, password });
      setError(false);
    } catch (error) {
      setError(true);
      let errorMessage: string;
      if (error instanceof Error) {
        errorMessage = error.message;
      } else {
        errorMessage = '認証コードの確認に失敗しました。';
      }
      throw new Error(errorMessage);
    }
  };

  const handleSignOut = async () => {
    const currentUser = await getCurrentUser();
    if (currentUser) {
      await signOut();
    }
  };

  // メールアドレスの変更と認証コードの送信
  const handleChangeEmail = async (email: string) => {
    try {
      await getCurrentUser();
      await updateUserAttribute({
        userAttribute: {
          attributeKey: 'email',
          value: email
        }
      });

      setError(false);
    } catch (error) {
      setError(true);
      let errorMessage: string;
      if (error instanceof Error) {
        errorMessage = error.message;
      } else {
        errorMessage = 'メールアドレスの変更に失敗しました。';
      }
      throw new Error(errorMessage);
    }
  };

  // メールアドレス変更時の認証コードの確認
  const handleConfirmChangeEmail = async (confirmationCode: string) => {
    try {
      await getCurrentUser();
      await confirmUserAttribute({
        userAttributeKey: 'email',
        confirmationCode: confirmationCode
      });
      setError(false);
    } catch (error) {
      setError(true);
      let errorMessage: string;
      if (error instanceof Error) {
        errorMessage = error.message;
      } else {
        errorMessage = '認証コードの確認に失敗しました。';
      }
      throw new Error(errorMessage);
    }
  };

  return {
    handleSignUp,
    handleConfirmSignUp,
    handleSignIn,
    handleSignOut,
    handleChangeEmail,
    handleConfirmChangeEmail,
    hasError
  };
};
